import { Button, Typography } from 'components';
import { useTranslations } from 'next-intl';
import { FC, MouseEvent } from 'react';
import { connect } from 'react-redux';

import { addToExcludedRanges, cancelTableSelection } from '../../_actions';
import { getSelectedRange } from '../../_selectors';

interface IExcludeSelectedPopup {
  cancelTableSelection: () => void;
  addToExcludedRanges: (range: { start: number; end: number }) => void;
  selectedRange: { start: number; end: number };
}

const ExcludeSelectedPopup: FC<IExcludeSelectedPopup> = ({
  cancelTableSelection,
  addToExcludedRanges,
  selectedRange
}) => {
  const t = useTranslations();

  const handleExclude = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    addToExcludedRanges(selectedRange);
  };

  const handleCancel = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    cancelTableSelection();
  };

  return (
    <div>
      <Typography variant="regular1" className="text-tertiary-100">
        {t('ordering_form.exclude.header')}
      </Typography>
      <div className="mb-2 mt-4">
        <Typography variant="light4" className="text-quaternary-300">
          {t('ordering_form.exclude.explanation')}
        </Typography>
      </div>
      <div className="flex gap-4">
        <Button variant="contained" size="medium" color="secondary" onClick={handleExclude}>
          {t('ordering_form.exclude.exclude_selection')}
        </Button>
        <Button variant="text" onClick={handleCancel}>
          {t('ordering_form.cancel')}
        </Button>
      </div>
    </div>
  );
};

export default connect((state) => ({ selectedRange: getSelectedRange(state) }), {
  cancelTableSelection,
  addToExcludedRanges
})(ExcludeSelectedPopup);
